import PDFBuilder, { fmtDate, fmtDateFromISO } from "../../utils/pdfBuilder.js";

const combustibilLabels = {
  benzina: "Benzina",
  motorina: "Motorina",
  GPL: "GPL",
  electric: "Electric",
  hibrid: "Hibrid",
};


export default function buildVanzareAutoPDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());
  const dataVanzareFmt = data.dataVanzare ? fmtDateFromISO(data.dataVanzare) : "___";

  const pret = Number(data.pretVanzare) || 0;
  const valuta = data.valuta || "RON";

  // Header
  pdf.title("Contract de Vanzare-Cumparare Auto", `Nr. ___ din ${today}`);

  // I. PARTILE CONTRACTANTE
  pdf.section("I. PARTILE CONTRACTANTE");

  pdf.pMixed([{ text: "1.1. Vanzatorul:", bold: true }]);
  pdf.renderPartyPFPJ(data, "vanzator", data.vanzatorPJ);

  pdf.italic("si");

  pdf.pMixed([{ text: "1.2. Cumparatorul:", bold: true }]);
  pdf.renderPartyPFPJ(data, "cumparator", data.cumparatorPJ);

  pdf.intro("au convenit incheierea prezentului contract de vanzare-cumparare, in conformitate cu dispozitiile Codului Civil, in urmatoarele conditii:");

  // II. OBIECTUL CONTRACTULUI
  pdf.section("II. OBIECTUL CONTRACTULUI");

  pdf.pMixed([
    { text: "2.1. ", bold: true },
    { text: "Vanzatorul vinde si transmite dreptul de proprietate, iar Cumparatorul cumpara si dobandeste dreptul de proprietate asupra autovehiculului cu urmatoarele caracteristici:" },
  ]);

  pdf.field("Marca", data.marca);
  pdf.field("Model", data.model);
  pdf.field("An fabricatie", data.anFabricatie);
  pdf.field("Nr. inmatriculare", data.nrInmatriculare);
  pdf.field("Serie sasiu (VIN)", data.serieSasiu);
  if (data.nrMotor) pdf.field("Nr. motor", data.nrMotor);
  if (data.culoare) pdf.field("Culoare", data.culoare);
  pdf.field("Combustibil", combustibilLabels[data.combustibil] || data.combustibil);
  if (data.capacitateCilindrica) pdf.field("Capacitate cilindrica", `${data.capacitateCilindrica} cmc`);
  if (data.kmRulati) {
    let kmText = `${Number(data.kmRulati).toLocaleString("ro-RO")} km`;
    if (data.kmDeclaratie === "estimativ") kmText += " (estimativ)";
    else if (data.kmDeclaratie === "necunoscut") kmText += " (necunoscut)";
    pdf.field("Kilometri rulati", kmText);
  }

  // III. PRETUL SI MODALITATEA DE PLATA
  pdf.section("III. PRETUL SI MODALITATEA DE PLATA");

  const pretFmt = pret > 0 ? pret.toLocaleString("ro-RO") : "___";
  const valutaSuffix = valuta !== "RON" ? ", platibil in lei la cursul BNR din data platii" : "";
  pdf.pMixed([
    { text: "3.1. ", bold: true },
    { text: "Pretul vanzarii este de " },
    { text: `${pretFmt} ${valuta}`, bold: true },
    { text: `${valutaSuffix}, pe care Cumparatorul se obliga sa il achite Vanzatorului.` },
  ]);

  let artNr = 2;

  if (data.modalitatePlata === "numerar + transfer") {
    const sumaNumerar = data.sumaNumerar ? Number(data.sumaNumerar).toLocaleString("ro-RO") : "___";
    let diferentaText = "";
    if (valuta === "RON") {
      const diferenta = pret > 0 && Number(data.sumaNumerar) > 0 ? (pret - Number(data.sumaNumerar)).toLocaleString("ro-RO") : "___";
      diferentaText = `, diferenta de ${diferenta} lei`;
    }
    pdf.pMixed([
      { text: `3.${artNr++}. `, bold: true },
      { text: "Pretul se achita partial in numerar, in suma de " },
      { text: `${sumaNumerar} lei`, bold: true },
      { text: `, si partial prin transfer bancar${diferentaText} reprezentand restul de plata.` },
    ]);

    pdf.pMixed([
      { text: `3.${artNr++}. `, bold: true },
      { text: "Plata in numerar se face cu respectarea plafonului legal." },
    ]);
  } else {
    pdf.pMixed([
      { text: `3.${artNr++}. `, bold: true },
      { text: "Plata se va efectua prin " },
      { text: data.modalitatePlata || "transfer bancar", bold: true },
      { text: ", cu respectarea legislatiei in vigoare privind plafonul platilor in numerar." },
    ]);
  }

  pdf.pMixed([
    { text: `3.${artNr++}. `, bold: true },
    { text: "Data vanzarii: " },
    { text: dataVanzareFmt, bold: true },
    { text: "." },
  ]);

  if (data.pretAchitatLaSemnare) {
    pdf.pMixed([
      { text: `3.${artNr++}. `, bold: true },
      { text: "Vanzatorul declara ca a primit de la Cumparator suma mentionata la art. 3.1, pretul fiind achitat integral la data semnarii prezentului contract." },
    ]);
  } else {
    pdf.pMixed([
      { text: `3.${artNr++}. `, bold: true },
      { text: "Pretul urmeaza a fi achitat conform modalitatii de plata convenite, cel tarziu la data predarii autovehiculului, daca partile nu convin altfel in scris." },
    ]);
  }

  pdf.pMixed([
    { text: `3.${artNr}. `, bold: true },
    { text: "Predarea efectiva a autovehiculului si a tuturor documentelor aferente (certificat de inmatriculare, cartea de identitate a vehiculului, chei, ITP, RCA) se face la data de " },
    { text: dataVanzareFmt, bold: true },
    { text: ", la momentul semnarii prezentului contract." },
  ]);

  // IV. STAREA TEHNICA A AUTOVEHICULULUI
  pdf.section("IV. STAREA TEHNICA A AUTOVEHICULULUI");

  pdf.pMixed([
    { text: "4.1. ", bold: true },
    { text: "Vanzatorul declara ca, la data vanzarii, autovehiculul se afla intr-o stare tehnica " },
    { text: data.stareTehnica || "buna", bold: true },
    { text: ", corespunzatoare utilizarii normale, conform evaluarii sale." },
  ]);

  pdf.pMixed([
    { text: "4.2. ", bold: true },
    { text: data.itpValid
      ? "Autovehiculul are inspectia tehnica periodica valabila la data vanzarii."
      : "Cumparatorul ia act ca autovehiculul nu are inspectia tehnica periodica valabila." },
  ]);

  pdf.pMixed([
    { text: "4.3. ", bold: true },
    { text: data.rcaValid
      ? "Autovehiculul are asigurare RCA valabila la data vanzarii."
      : "Cumparatorul ia act ca autovehiculul nu are asigurare RCA valabila." },
  ]);

  pdf.pMixed([
    { text: "4.4. ", bold: true },
    { text: data.liberSarcini
      ? "Vanzatorul declara ca autovehiculul este liber de orice sarcini, gajuri, sechestre sau alte drepturi ale tertilor."
      : "Cumparatorul a fost informat despre existenta urmatoarelor sarcini: _________________________." },
  ]);

  let stareNr = 5;

  if (data.kmDeclaratie === "real" && data.kmRulati) {
    const kmFmt = Number(data.kmRulati).toLocaleString("ro-RO");
    pdf.pMixed([
      { text: `4.${stareNr++}. `, bold: true },
      { text: "Vanzatorul declara pe propria raspundere ca kilometrajul indicat de " },
      { text: `${kmFmt} km`, bold: true },
      { text: " este real si corespunde starii efective a autovehiculului." },
    ]);
  }

  if (data.kmDeclaratie === "estimativ") {
    const kmPart = data.kmRulati ? ` de ${Number(data.kmRulati).toLocaleString("ro-RO")} km` : "";
    pdf.pMixed([
      { text: `4.${stareNr++}. `, bold: true },
      { text: `Vanzatorul declara ca kilometrajul afisat${kmPart} are caracter ` },
      { text: "estimativ", bold: true },
      { text: " si nu este garantat ca fiind real." },
    ]);
  }

  if (data.kmDeclaratie === "necunoscut") {
    pdf.pMixed([
      { text: `4.${stareNr++}. `, bold: true },
      { text: "Vanzatorul declara ca nu poate garanta caracterul real al kilometrajului afisat, acesta fiind " },
      { text: "necunoscut", bold: true },
      { text: "." },
    ]);
  }

  pdf.pMixed([
    { text: `4.${stareNr++}. `, bold: true },
    { text: "Vanzatorul declara ca nu a modificat si nu a dispus modificarea kilometrajului autovehiculului." },
  ]);

  pdf.pMixed([
    { text: `4.${stareNr}. `, bold: true },
    { text: "Cumparatorul declara ca a inspectat autovehiculul si il accepta in starea in care se afla la momentul vanzarii (" },
    { text: "vandut ca atare", bold: true },
    { text: "). Vanzatorul a adus la cunostinta Cumparatorului toate informatiile relevante privind starea tehnica a autovehiculului." },
  ]);

  // V. OBLIGATIILE VANZATORULUI
  pdf.section("V. OBLIGATIILE VANZATORULUI");

  const obligatiiVanzator = [
    "Sa predea Cumparatorului autovehiculul descris la art. II, in starea tehnica constatata de ambele parti.",
    "Sa predea toate documentele aferente autovehiculului: certificat de inmatriculare, cartea de identitate a vehiculului, chei, ITP, RCA si orice alte documente necesare.",
    "Sa garanteze Cumparatorul impotriva evictiunii totale sau partiale, conform dispozitiilor Codului Civil.",
    "Sa declare ca autovehiculul nu face obiectul niciunui litigiu si nu este sechestrat sau indisponibilizat.",
    `Sa declare ca autovehiculul ${data.liberSarcini ? "este liber de orice sarcini" : "are sarcinile comunicate Cumparatorului"}.`,
    "Sa radieze autovehiculul din evidenta fiscala in termen de 30 de zile de la data incheierii prezentului contract.",
  ];
  obligatiiVanzator.forEach((text, i) => {
    pdf.article(`5.${i + 1}.`, text);
  });

  // VI. OBLIGATIILE CUMPARATORULUI
  pdf.section("VI. OBLIGATIILE CUMPARATORULUI");

  const obligatiiCumparator = [
    "Sa achite integral pretul convenit conform art. III din prezentul contract.",
    "Sa efectueze fomalitatile de transcriere/inmatriculare a autovehiculului pe numele sau, in termenul prevazut de lege.",
    "Sa incheie o asigurare obligatorie RCA pe numele sau, inainte de punerea in circulatie a autovehiculului.",
    "Sa preia autovehiculul la data si locul convenite.",
  ];
  obligatiiCumparator.forEach((text, i) => {
    pdf.article(`6.${i + 1}.`, text);
  });

  // Dynamic section numbering based on garantieActiva
  let sectionNum = 7;

  // VII. GARANTIE (conditional)
  if (data.garantieActiva) {
    pdf.section(`${toRoman(sectionNum)}. GARANTIE`);
    const gn = sectionNum;

    const luniText = Number(data.garantieLuni) === 1 ? "luna" : "luni";
    pdf.pMixed([
      { text: `${gn}.1. `, bold: true },
      { text: "Vanzatorul acorda Cumparatorului o garantie de " },
      { text: `${data.garantieLuni || "3"} ${luniText}`, bold: true },
      { text: " de la data semnarii prezentului contract, pentru viciile ascunse ale autovehiculului." },
    ]);

    const componente = [
      data.garantieMotor && "motor",
      data.garantieCutie && "cutie de viteze",
      data.garantieFranare && "sistem de franare",
      data.garantieAlte && data.garantieAlteText?.trim(),
    ].filter(Boolean).join(", ") || "___";

    pdf.pMixed([
      { text: `${gn}.2. `, bold: true },
      { text: "Garantia acopera urmatoarele componente: " },
      { text: componente, bold: true },
      { text: "." },
    ]);

    pdf.article(`${gn}.3.`, "Garantia nu acopera uzura normala, consumabilele si defectele aparute ca urmare a utilizarii necorespunzatoare.");
    pdf.article(`${gn}.4.`, "Garantia acordata este una limitata, strict pentru componentele mentionate mai sus, si nu reprezinta o garantie comerciala generala.");
    pdf.article(`${gn}.5.`, "Raspunderea Vanzatorului pentru vicii ascunse este limitata la termenul si componentele pentru care s-a acordat garantia, in masura permisa de lege.");
    pdf.article(`${gn}.6.`, "In perioada de garantie, Vanzatorul se obliga sa remedieze pe cheltuiala proprie defectiunile acoperite sau sa restituie o parte proportionala din pretul de vanzare.");

    sectionNum++;
  }

  // RASPUNDERE
  const raspundereNum = sectionNum;
  pdf.section(`${toRoman(raspundereNum)}. RASPUNDERE`);

  if (data.garantieActiva) {
    pdf.article(`${raspundereNum}.1.`, "Vanzatorul raspunde pentru viciile ascunse ale autovehiculului, in conformitate cu dispozitiile art. 1707-1714 din Codul Civil, daca acestea existau la momentul vanzarii si nu au fost aduse la cunostinta Cumparatorului.");
    pdf.article(`${raspundereNum}.2.`, "Cumparatorul este obligat sa verifice autovehiculul la momentul preluarii. Viciile aparente constatate la predare si nesemnalate in procesul de receptie se considera acceptate.");
    pdf.article(`${raspundereNum}.3.`, "In cazul descoperirii de vicii ascunse, Cumparatorul poate solicita reducerea pretului sau rezolutiunea contractului, conform legii.");
  } else {
    pdf.pMixed([
      { text: `${raspundereNum}.1. `, bold: true },
      { text: "Vanzarea se face in starea in care autovehiculul se afla la momentul tranzactiei, cu excluderea garantiei pentru vicii ascunse, in masura permisa de lege." },
    ]);
    pdf.pMixed([
      { text: `${raspundereNum}.2. `, bold: true },
      { text: "Cumparatorul declara ca a inspectat autovehiculul, ca a fost informat asupra starii tehnice a acestuia si ca il accepta in starea constatata (" },
      { text: "vandut ca atare", bold: true },
      { text: ")." },
    ]);
    pdf.article(`${raspundereNum}.3.`, "Vanzatorul raspunde in continuare pentru viciile pe care le-a ascuns cu intentie sau pentru declaratiile false privind starea autovehiculului, conform art. 1712 din Codul Civil.");
  }
  sectionNum++;

  // LITIGII
  const litigiiNum = sectionNum;
  pdf.section(`${toRoman(litigiiNum)}. LITIGII`);
  pdf.article(`${litigiiNum}.1.`, "Litigiile decurgand din executarea prezentului contract se solutioneaza pe cale amiabila, iar in caz contrar de catre instantele judecatoresti competente.");
  sectionNum++;

  // DISPOZITII FINALE
  const finaleNum = sectionNum;
  pdf.section(`${toRoman(finaleNum)}. DISPOZITII FINALE`);
  pdf.article(`${finaleNum}.1.`, "Prezentul contract constituie titlu de proprietate si poate fi utilizat pentru transcrierea autovehiculului in evidentele autoritatilor competente.");
  pdf.article(`${finaleNum}.2.`, "Orice modificare a prezentului contract se face prin act aditional semnat de ambele parti.");
  pdf.article(`${finaleNum}.3.`, "Cheltuielile privind transcrierea autovehiculului si taxele aferente sunt suportate de Cumparator.");
  pdf.article(`${finaleNum}.4.`, "Prezentul contract reprezinta vointa partilor si inlocuieste orice intelegere anterioara, verbala sau scrisa.");
  pdf.article(`${finaleNum}.5.`, `Contractul se incheie in 2 (doua) exemplare originale, cate unul pentru fiecare parte${data.martori ? ", plus cate un exemplar pentru fiecare martor" : ""}.`);

  // Signatures: VANZATOR | CUMPARATOR
  const vanzatorName = pdf.getPartyNamePFPJ(data, "vanzator", data.vanzatorPJ);
  const cumparatorName = pdf.getPartyNamePFPJ(data, "cumparator", data.cumparatorPJ);

  pdf.signatures(
    { role: "VANZATOR", name: vanzatorName, date: today },
    { role: "CUMPARATOR", name: cumparatorName, date: today },
  );

  // Conditional MARTOR 1 | MARTOR 2
  if (data.martori) {
    pdf.signatures(
      { role: "MARTOR 1", name: "", date: today },
      { role: "MARTOR 2", name: "", date: today },
    );
  }

  pdf.save(filename);
}

function toRoman(num) {
  const map = [
    [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"],
  ];
  let result = "";
  for (const [value, numeral] of map) {
    while (num >= value) {
      result += numeral;
      num -= value;
    }
  }
  return result;
}
